import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { CheckCircle2Icon, LockIcon, ZapIcon, SmartphoneIcon, StarIcon } from 'lucide-react';
export function PricingSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section id="get-access" ref={ref} className="relative py-16 md:py-24 overflow-hidden" data-id="element-545">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-neutral-950 via-black to-black" data-id="element-546" />
      <div className="absolute inset-0 opacity-15" style={{
      backgroundImage: `url('https://cdn.magicpatterns.com/uploads/mmZsZjhR9eRY4yFwjZNjVf/CONTRA_PORTADA.png')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }} data-id="element-547" />
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/85 to-black/70" data-id="element-548" />

      <div className="relative z-10 max-w-3xl mx-auto px-6" data-id="element-549">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-10" data-id="element-550">
          <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-wider uppercase border rounded-full bg-teal-500/20 text-teal-400 border-teal-500/30 mb-6" data-id="element-551">
            Get the Complete Pack
          </span>
          <p className="text-neutral-400 text-lg" data-id="element-552">
            Ebook + Audiobook — Everything in One Purchase
          </p>
        </motion.div>

        {/* Pricing Card */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative" data-id="element-553">
          {/* Glow */}
          <div className="absolute -inset-1 bg-gradient-to-r from-teal-500 via-cyan-500 to-teal-500 rounded-3xl blur-xl opacity-20" data-id="element-554" />

          <div className="relative rounded-3xl bg-gradient-to-br from-neutral-900 to-black border border-teal-500/30 overflow-hidden" data-id="element-555">
            {/* Book info */}
            <div className="p-8 md:p-10 text-center" data-id="element-556">
              <h3 className="font-serif text-2xl md:text-3xl text-white font-bold mb-1" data-id="element-557">
                WHO WE ARE, WHO THEY ARE,
                <br data-id="element-558" />
                AND WHAT THEY HIDE…
              </h3>
              <p className="font-serif text-lg text-teal-400 italic mb-2" data-id="element-559">
                How to Play the Real Game
              </p>
              <p className="text-neutral-500 text-sm" data-id="element-560">
                by Nicolás Pereira & Gabriel Beltrán
              </p>
            </div>

            <div className="border-t border-neutral-800/50 mx-8" data-id="element-561" />

            {/* Pricing */}
            <div className="p-8 md:p-10 text-center" data-id="element-562">
              <p className="text-neutral-500 text-lg mb-2" data-id="element-563">
                Regular Price: <span className="line-through" data-id="element-564">$47</span>
              </p>
              <div className="flex items-center justify-center gap-3 mb-2" data-id="element-565">
                <StarIcon className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-566" />
                <span className="text-4xl md:text-5xl font-bold text-white" data-id="element-567">
                  $17
                </span>
                <StarIcon className="w-5 h-5 text-amber-400 fill-amber-400" data-id="element-568" />
              </div>
              <p className="text-teal-400 text-sm font-semibold uppercase tracking-wider" data-id="element-569">
                Today Only
              </p>
            </div>

            <div className="border-t border-neutral-800/50 mx-8" data-id="element-570" />

            {/* Includes */}
            <div className="p-8 md:p-10 space-y-3" data-id="element-571">
              <div className="flex items-center gap-3" data-id="element-572">
                <CheckCircle2Icon className="w-5 h-5 text-teal-400 flex-shrink-0" data-id="element-573" />
                <span className="text-neutral-300 text-sm" data-id="element-574">
                  Complete 13-Chapter Ebook
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-575">
                <CheckCircle2Icon className="w-5 h-5 text-teal-400 flex-shrink-0" data-id="element-576" />
                <span className="text-neutral-300 text-sm" data-id="element-577">
                  Full Audiobook — Professional Narration
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-578">
                <CheckCircle2Icon className="w-5 h-5 text-teal-400 flex-shrink-0" data-id="element-579" />
                <span className="text-neutral-300 text-sm" data-id="element-580">
                  PDF + EPUB formats
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-581">
                <CheckCircle2Icon className="w-5 h-5 text-teal-400 flex-shrink-0" data-id="element-582" />
                <span className="text-neutral-300 text-sm" data-id="element-583">
                  Instant access on any device
                </span>
              </div>
              <div className="flex items-center gap-3" data-id="element-584">
                <CheckCircle2Icon className="w-5 h-5 text-teal-400 flex-shrink-0" data-id="element-585" />
                <span className="text-neutral-300 text-sm" data-id="element-586">
                  Listen offline — High quality MP3
                </span>
              </div>
            </div>

            <div className="border-t border-neutral-800/50 mx-8" data-id="element-587" />

            {/* CTA */}
            <div className="p-8 md:p-10 text-center" data-id="element-588">
              <a href="https://momentumdigitalpro.com/cart/44809832005734:1" className="inline-flex items-center gap-3 px-10 py-5 text-base md:text-lg font-bold text-black bg-gradient-to-r from-teal-400 to-cyan-400 rounded-xl shadow-lg shadow-teal-500/30 hover:shadow-teal-500/50 hover:scale-105 transition-all duration-300 uppercase tracking-wide w-full justify-center" data-id="element-589">
                <ZapIcon className="w-5 h-5" data-id="element-590" />
                GET THE PACK — $17 TODAY →
              </a>

              <p className="mt-5 text-neutral-600 text-xs flex items-center justify-center gap-4 flex-wrap" data-id="element-591">
                <span className="inline-flex items-center gap-1" data-id="element-592">
                  <LockIcon className="w-3 h-3" data-id="element-593" /> Secure Checkout
                </span>
                <span data-id="element-594">•</span>
                <span data-id="element-595">Instant Access</span>
                <span data-id="element-596">•</span>
                <span className="inline-flex items-center gap-1" data-id="element-597">
                  <SmartphoneIcon className="w-3 h-3" data-id="element-598" /> Any Device
                </span>
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}